export const DAILY_PAYOUT_PER_MONTH_LOCATION_PRICE = 39500;
export const SPLIT_PAYMENT_MONTHLY_FEE = 299000;
export const SPLIT_PAYMENT_MONTHLY_FEE_PER_SELLER = 4900;
export const SPLIT_PAYMENT_MONTHLY_FEE_PER_PAYOUT_TO_SELLER = 550;
